export const FILTER_PERSONS = 'persons';
export const FILTER_LOCATIONS = 'location__in';
export const FILTER_SEARCH = 'search';
